import { getBrand, type CUIBrandType } from "./useCuiConfig";

/**
 * Gets the current brand from global CUI config.
 * Set via setupCUIConfig({ brand: "wh" })
 * Returns "czr" by default.
 */
export const useBrandTheme = (): CUIBrandType => getBrand();
